import React from "react";
import Icon from "./Icon";
export default function Pause(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 3.66667H5.5V18.3333H9.16667V3.66667Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.66667H12.8333V18.3333H16.5V3.66667Z"
  }));
}
Pause.displayname = "Pause";
//# sourceMappingURL=Pause.js.map